import { useNavigate } from "react-router-dom";
import { UserCheck, FileSignature, Briefcase, ArrowRight } from "lucide-react";

const ADDONS = [
  {
    key: "registered_agent",
    icon: UserCheck,
    name: "Registered Agent Service",
    price: "$75 / yr",
    desc: "We act as your Texas registered agent — a real Texas street address on public record instead of your home, with mail forwarding.",
    best: "Best if you work from home or move often",
  },
  {
    key: "operating_agreement",
    icon: FileSignature,
    name: "Operating Agreement Drafting",
    price: "$50 one-time",
    desc: "A custom operating agreement for your single- or multi-member LLC, written for Texas and delivered in 3 business days.",
    best: "Best for LLCs with partners or investors",
  },
  {
    key: "done_for_you",
    icon: Briefcase,
    name: "Done-for-you Formation",
    price: "$199 + state fee",
    desc: "We prepare and file your Certificate of Formation, obtain your EIN, draft your agreement and include a year of registered agent.",
    best: "Best if you'd rather not touch the paperwork",
  },
];

export default function AddOnsStrip() {
  const navigate = useNavigate();
  return (
    <section data-testid="addons-strip" className="px-4 pb-6 sm:pb-8">
      <div className="mx-auto max-w-5xl">
        <div className="mb-6 text-center">
          <p className="mb-3 inline-flex rounded-full border-2 border-[var(--c-border)] bg-[var(--c-surface)] px-3 py-1 text-[10px] font-bold uppercase tracking-[0.15em] text-[#1E3A8A] shadow-[2px_2px_0px_var(--c-shadow)]">Popular add-ons</p>
          <h2 className="font-heading text-2xl font-black text-[var(--c-text)] sm:text-3xl">Do it yourself — or hand off the parts you don&apos;t want to.</h2>
          <p className="mt-2 text-sm text-[var(--c-muted)]">Every add-on is optional, one-time or yearly, and available from inside your guide. No subscriptions sneak in.</p>
        </div>
        <div className="grid gap-4 md:grid-cols-3">
          {ADDONS.map(({ key, icon: Icon, name, price, desc, best }) => (
            <div key={key} data-testid={`addon-${key}`} className="flex flex-col rounded-2xl border-2 border-[var(--c-border)] bg-[var(--c-surface)] p-5 shadow-[4px_4px_0px_var(--c-shadow)]">
              <div className="flex items-start justify-between gap-3">
                <div className="flex h-11 w-11 items-center justify-center rounded-xl border-2 border-[var(--c-border)] bg-[#1E3A8A] text-white"><Icon className="h-5 w-5" /></div>
                <span className="rounded-full border-2 border-[var(--c-border)] bg-[var(--c-bg)] px-3 py-1 text-xs font-black text-[var(--c-text)]">{price}</span>
              </div>
              <h3 className="mt-4 font-heading text-lg font-black text-[var(--c-text)]">{name}</h3>
              <p className="mt-1.5 flex-1 text-sm leading-relaxed text-[var(--c-muted)]">{desc}</p>
              <p className="mt-3 text-[11px] font-semibold uppercase tracking-wide text-[#C8102E]">{best}</p>
              <button
                data-testid={`addon-cta-${key}`}
                onClick={() => navigate(key === "done_for_you" ? "/login?mode=register&next=service" : "/login?mode=register")}
                className="mt-4 inline-flex items-center gap-1.5 text-sm font-bold text-[#1E3A8A] underline decoration-2 underline-offset-4"
              >
                {key === "done_for_you" ? "Request it" : "Add it inside the guide"} <ArrowRight className="h-4 w-4" />
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
